import React from 'react';

import { CareerProps } from '@utils/aboutInterfaces';
import { BENEFITS } from '@utils/constants';
import { getImgxSrc } from '@utils/images';

import OpenPositions from './OpenPositions';

const Careers = ({ env, jobs }: CareerProps) => {
  return (
    <article>
      <div className="max-w-2xl">
        <h2 className="mb-24 font-suisse-works text-headline-md">Careers</h2>
        <div className="font-suisse-neue text-body-lg">
          The Information is seeking individuals passionate about the future of the news business
          for the roles below.
        </div>
      </div>
      <div className="my-48 grid grid-cols-2 gap-48  sm:grid-cols-3 lg:grid-cols-4">
        {BENEFITS.map((benefit) => (
          <div key={benefit.label} className="flex flex-col items-center gap-16">
            <img
              src={getImgxSrc({ path: benefit.icon, isDevDependence: true, envContext: env })}
              alt={benefit.label}
              className="h-[70px] w-[70px]"
            />
            <div className="font-suisse-intl text-body-sm font-bold">{benefit.label}</div>
          </div>
        ))}
      </div>
      <OpenPositions jobs={jobs} />
    </article>
  );
};

export default Careers;
